import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    layout: {
      message: {
        header: "ล้วงไห 2564",
        footer: "วัดใหม่ลำนกแขวก"
      }
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
